import { SessionEventType } from "./SessionEventType"
import { DropdownItem, DropdownMenu, DropdownToggle, UncontrolledDropdown } from "reactstrap"
import { ThreeDots } from "react-bootstrap-icons"
import { useNavigate } from "react-router-dom"

export const SessionEventList = ({ data, totalPages, pageIndex, setPageIndex, role }) => {

    const navigate = useNavigate();

    return (
        <div>
            <div className="table-responsive">
                <table className="w-100 table table-hover">
                    <thead>
                        <tr>
                            <th>Название</th>
                            <th>Дата</th>
                            <th>Тип</th>
                            <th style={{
                                verticalAlign: "middle",
                                textAlign: "center"
                            }}>Статус</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        {data && data.length > 0 ?
                            data.map(event =>
                                <tr key={event.id}>
                                    <td>{event.title}</td>
                                    <td>{event.dateEvent}</td>
                                    <td>
                                        <SessionEventType eventType={event.typeOfEvent} />
                                    </td>
                                    <td style={{
                                        verticalAlign: "middle",
                                        textAlign: "center"
                                    }}>{event.status ? <span className="text-success">Ативен</span> : <span className="text-secondary">Не активен</span>}</td>
                                    <td>
                                        <UncontrolledDropdown>
                                            <DropdownToggle color="light" >
                                                <ThreeDots className='' size='14' />
                                            </DropdownToggle>
                                            <DropdownMenu container="body">
                                                {(role === "Admins" || role === "Сashier" || role === "BookingManager") && <>
                                                    <DropdownItem onClick={() => navigate('details/' + event.id)}>Подробнее</DropdownItem>
                                                    {(event.typeOfEvent === 4 || event.typeOfEvent === 1) &&
                                                        <DropdownItem onClick={() => navigate('queuescreen/' + event.id)}>Экран</DropdownItem>
                                                    }
                                                </>
                                                }
                                                <DropdownItem onClick={() => navigate('list/' + event.id)}>Список</DropdownItem>
                                            </DropdownMenu>
                                        </UncontrolledDropdown>
                                    </td>
                                </tr>
                            )
                            :
                            <tr><td colSpan={5} className="text-center">Список пуст</td></tr>
                        }
                    </tbody>
                </table>
            </div>
            <div className="d-flex flex-row justify-content-center align-content-center mt-3 mb-3">
                <div className="btn-group">
                    <button
                        className={pageIndex === 1 ? `btn btn-primary disabled` : `btn btn-primary`}
                        onClick={() => {
                            if (pageIndex > 1) {
                                setPageIndex(pageIndex - 1)
                            }
                        }}>Назад</button>
                    <button
                        className={(pageIndex === totalPages || totalPages === 0) ? `btn btn-primary disabled` : `btn btn-primary`}
                        onClick={
                            () => {
                                if (pageIndex <= totalPages) {
                                    setPageIndex(pageIndex + 1)
                                }
                            }}
                    >Вперед</button>
                </div>
            </div>
        </div>
    )
} 